import React from 'react';
import { Translations } from '../i18n/translations';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { Categories } from '../components/Categories';
import { Testimonials } from '../components/Testimonials';
import { BestSellers } from '../components/BestSellers';
interface HomeProps {
  t: Translations;
  setPage: (page: 'home' | 'product', slug?: string) => void;
}
export const Home: React.FC<HomeProps> = ({
  t,
  setPage
}) => {
  return <main className="w-full min-h-screen" data-id="element-374">
      <Hero t={t} setPage={setPage} data-id="element-375" />
      <TrustStrip t={t} data-id="element-376" />
      <Categories t={t} setPage={setPage} data-id="element-377" />
      <Testimonials t={t} data-id="element-378" />
      <BestSellers t={t} setPage={setPage} data-id="element-379" />
    </main>;
};